module.exports = __webpack_public_path__ + "static/media/InvitationCode.b783c91f.svg";